import React from 'react'

interface GenericStoreProps {
  className?: string
}

const GenericStore: React.FC<GenericStoreProps> = ({
  className,
}: GenericStoreProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
      fill="#252324"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7326 4.75C14.1444 4.75 14.5034 5.03027 14.6033 5.42978L15.3308 8.33974C15.3308 9.02125 14.9509 9.61404 14.3914 9.91798C14.1371 10.0561 13.8457 10.1346 13.5359 10.1346C13.5049 10.1346 13.4741 10.1338 13.4435 10.1323C13.1627 10.118 12.899 10.0393 12.6668 9.91054C12.6207 9.88499 12.5758 9.85746 12.5324 9.82808C12.0553 9.50581 11.7416 8.96025 11.741 8.34136C11.7404 9.01667 11.3669 9.60468 10.8152 9.91054C10.8107 9.91304 10.8062 9.91552 10.8017 9.91798C10.5474 10.0561 10.2559 10.1346 9.94614 10.1346C9.91516 10.1346 9.88437 10.1338 9.85377 10.1323C9.573 10.118 9.30924 10.0393 9.07704 9.91055C9.07704 9.91055 9.07704 9.91054 9.07704 9.91054C9.03095 9.88499 8.9861 9.85746 8.94261 9.82808C8.46562 9.50583 8.15186 8.96032 8.15127 8.34149C8.15118 8.43361 8.14415 8.52411 8.13068 8.61248C8.12272 8.66468 8.11251 8.71614 8.10016 8.76675C7.98013 9.25863 7.6574 9.67107 7.2255 9.91054C7.22099 9.91304 7.21647 9.91552 7.21194 9.91798C6.95762 10.0561 6.66617 10.1346 6.3564 10.1346C6.32542 10.1346 6.29462 10.1338 6.26403 10.1323C5.97177 10.1175 5.69795 10.0327 5.45896 9.89449C4.92247 9.58415 4.56152 9.0041 4.56152 8.33974L5.28902 5.42978C5.38889 5.03027 5.74785 4.75 6.15966 4.75H8.33075H11.5615H13.7326ZM5.45896 11.75V11.3507C5.74332 11.4353 6.04455 11.4808 6.35639 11.4808C7.02375 11.4808 7.64249 11.2726 8.15127 10.9178C8.66004 11.2726 9.27878 11.4808 9.94614 11.4808C10.6135 11.4808 11.2322 11.2726 11.741 10.9178C12.2498 11.2726 12.8685 11.4808 13.5359 11.4808C13.8477 11.4808 14.149 11.4353 14.4333 11.3507V11.75C14.4333 12.7552 14.4333 13.2578 14.2377 13.6418C14.0656 13.9795 13.791 14.2541 13.4533 14.4262C13.0694 14.6218 12.5667 14.6218 11.5615 14.6218H8.33075C7.32553 14.6218 6.82292 14.6218 6.43898 14.4262C6.10125 14.2541 5.82667 13.9795 5.65459 13.6418C5.45896 13.2578 5.45896 12.7552 5.45896 11.75Z"
      fill="#F5F5F5"
    />
  </svg>
)

export default GenericStore
